import { MetricModule } from './../../metric/metric.module';
import { IssuerModule } from './../../issuer/issuer.module';
import { InsurerModule } from './../../insurer/insurer.module';
import { AnalyticModule } from './../../analytic/analytic.module';
import { PatientMergeModule } from './../../patient/patient-merge/patient-merge.module';
import { PatientImportModule } from './../../patient/patient-import/patient-import.module';
import { PayerBillingModule } from 'src/app/payer-billing/payer-billing.module';
import { PayerBillingListComponent } from 'src/app/payer-billing/payer-billing-list/payer-billing-list.component';
import { GenerateInvoiceComponent } from 'src/app/payer-billing/generate-invoice/generate-invoice.component';
import { CBOPaymentsModule } from './../../cbo-payments/cbo-payments.module';
import { CBOPaymentsListComponent } from './../../cbo-payments/cbo-payments-list/cbo-payments-list.component';
import { AuthGuardService } from './auth-guard.service';
import { TermAndConditionModule } from './../../term-and-condition/term-and-condition.module';
import { TermAndConditionListComponent } from './../../term-and-condition/term-and-condition-list/term-and-condition-list.component';
import { CommunityModule } from './../../community/community.module';
import { EmailTemplateModule } from './../../email-template/email-template.module';
import { NoticeModule } from '../../notice/notice.module';
import { SystemNoteModule } from '../../system-note/system-note.module';
import { CodeSetEditComponent } from './../../codeset/codeset-edit/codeset-edit.component';
import { CodesetModule } from 'src/app/codeset/codeset.module';
import { CaseModule } from './../../case/case.module';
import { MemberModule } from './../../member/member.module';
import { MessageModule } from './../../message/message.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HelpComponent } from '../help/help.component';
import { LoginComponent } from '../login/login.component';
import { CaseListComponent } from '../../case/case-list/case-list.component';
import { MemberListComponent } from '../../member/member-list/member-list.component';
import { MessageListComponent } from '../../message/message-list/message-list.component';
import { UserListComponent } from '../../user/user-list/user-list.component';
import { ProgramListComponent } from '../../program/program-list/program-list.component';
import { ChannelDetailComponent } from '../../channel/channel-detail/channel-detail.component';
import { ChannelRuleComponent } from '../../channel/channel-rule/channel-rule.component';
import { ChannelModelerComponent } from '../../channel/channel-modeler/channel-modeler.component';
import { TaskListComponent } from '../../task/task-list/task-list.component';
import { ChannelEditComponent } from '../../channel/channel-edit/channel-edit.component';
import { CaseDetailComponent } from '../../case/case-detail/case-detail.component';
import { FieldConfigurationListComponent } from 'src/app/field-configuration/field-configuration-list/field-configuration-list.component';
import { UserModule } from 'src/app/user/user.module';
import { OrganizationModule } from 'src/app/organization/organization.module';
import { ProgramModule } from 'src/app/program/program.module';
import { TaskModule } from 'src/app/task/task.module';
import { FieldConfigurationModule } from 'src/app/field-configuration/field-configuration.module';
import { ChannelGroupListComponent } from 'src/app/channel/channel-group/channel-group-list/channel-group-list.component';
import { UserAccountComponent } from 'src/app/user/user-account/user-account/user-account.component';
import { UserConfirmComponent } from 'src/app/user/user-confirm/user-confirm.component';
import { NotFoundComponent } from 'src/app/shared/not-found/not-found.component';
import { CanDeactivateGuard } from './can-deactivate-guard.service';
import { ProgramCategoryListComponent } from 'src/app/program/program-category/program-category-list/program-category-list.component';
import { OrganizationListComponent } from 'src/app/organization/organization-list/organization-list.component';
import { ProgramTemplateListComponent } from 'src/app/program/program-template/program-template-list/program-template-list.component';
import { SettingListComponent } from 'src/app/setting/setting-list/setting-list.component';
import { SettingModule } from 'src/app/setting/setting.module';
import { AssessmentListComponent } from 'src/app/assessment/assessment-list/assessment-list.component';
import { AssessmentModule } from './../../assessment/assessment.module';
import { DashboardCoordinatorModule } from 'src/app/dashboard/dashboard-coordinator/dashboard-coordinator.module';
import { DashboardCoordinatorComponent } from 'src/app/dashboard/dashboard-coordinator/dashboard-coordinator.component';
import { NoticeListComponent } from 'src/app/notice/notice-list/notice-list.component';
import { SystemNoteListComponent } from 'src/app/system-note/system-note-list/system-note-list.component';
import { ClinicalMessageListComponent } from 'src/app/clinical-message/clinical-message-list/clinical-message-list.component';
import { ClinicalMessageModule } from 'src/app/clinical-message/clinical-message.module';
import { PatientModule } from 'src/app/patient/patient.module';
import { PatientSummaryComponent } from 'src/app/patient/patient-summary/patient-summary.component';
import { AnalyticViewComponent } from 'src/app/analytic/analytic-view/analytic-view.component';
import { ClinicalEventListComponent } from 'src/app/clinical-event/clinical-event-list/clinical-event-list.component';
import { ClinicalEventModule } from 'src/app/clinical-event/clinical-event.module';
import { ProviderListComponent } from 'src/app/provider/provider-list/provider-list.component';
import { ProviderModule } from 'src/app/provider/provider.module';
import { AssessmentTypeListComponent } from 'src/app/assessment/assessment-type/assessment-type-list/assessment-type-list.component';
import { ProgramEditComponent } from 'src/app/program/program-edit/program-edit.component';
import { ChannelModule } from 'src/app/channel/channel.module';
import { TeamRoleListComponent } from 'src/app/team/team-role/team-role-list/team-role-list.component';
import { EmailTemplateListComponent } from 'src/app/email-template/email-template-list/email-template-list.component';
import { VideoProviderListComponent } from 'src/app/video-provider/video-provider-list/video-provider-list.component';
import { VideoProviderModule } from 'src/app/video-provider/video-provider.module';
import { AppointmentConfirmComponent } from 'src/app/appointment/appointment-confirm/appointment-confirm.component';
import { CommunityServiceCategoryListComponent }
  from 'src/app/community/community-service-category/community-service-category-list/community-service-category-list.component';
import { CommunityProviderProgramListComponent }
  from 'src/app/community/community-provider-program/community-provider-program-list/community-provider-program-list.component';
import { FacilityListComponent } from 'src/app/facility/facility-list/facility-list.component';
import { FacilityModule } from 'src/app/facility/facility.module';
import { SettingNavComponent } from '../setting-nav/setting-nav.component';
import { ChannelCategoryListComponent } from 'src/app/channel/channel-category/channel-category-list/channel-category-list.component';
import { PatientImportListComponent } from 'src/app/patient/patient-import/patient-import-list/patient-import-list.component';
import { ReportListComponent } from 'src/app/report/report-list/report-list.component';
import { ReportModule } from 'src/app/report/report.module';
import { ExtensionListComponent } from 'src/app/extension/extension-list/extension-list.component';
import { ExtensionModule } from 'src/app/extension/extension.module';
import { TaskListReferralComponent } from 'src/app/task/task-list-referral/task-list-referral.component';
import { MemberAssessmentComponent } from 'src/app/shared/member-assessment/member-assessment/member-assessment.component';
import { PatientMergeComponent } from 'src/app/patient/patient-merge/patient-merge.component';
import { HelpDocumentModule } from 'src/app/help-document/help-document.module';
import { HelpDocumentListComponent } from 'src/app/help-document/help-document-list/help-document-list.component';
import { MetricListComponent } from 'src/app/metric/metric-list/metric-list.component';
import { IssuerListComponent } from 'src/app/issuer/issuer-list/issuer-list.component';
import { InsurerListComponent } from 'src/app/insurer/insurer-list/insurer-list.component';
import { AnalyticListComponent } from 'src/app/analytic/analytic-list/analytic-list.component';
import { ProgramDetailComponent } from 'src/app/program/program-detail/program-detail.component';
import { TestModule } from 'src/app/test/test.module';
import { TestComponent } from 'src/app/test/test.component';
import { CommunityServiceSearchComponent } from 'src/app/community/community-service-search/community-service-search.component';
import { ProviderServiceSearchComponent } from 'src/app/provider/provider-service-search/provider-service-search.component';
import { Kno2ServiceSearchComponent } from 'src/app/provider/kno2-service-search/kno2-service-search.component';
import { TotpComponent } from '../totp/totp.component';
import { IntegrityListComponent } from 'src/app/integrity/integrity-list/integrity-list.component';
import { IntegrityModule } from 'src/app/integrity/integrity.module';
import { DocumentLinkUploadComponent } from 'src/app/document/document-link-upload/document-link-upload.component';
import { SmartLaunchComponent } from '../smart/smart-launch/smart-launch.component';
import { SmartRedirectComponent } from '../smart/smart-redirect/smart-redirect.component';
import { FhirSummaryComponent } from 'src/app/fhir/fhir-summary/fhir-summary.component';
import { FhirModule } from 'src/app/fhir/fhir.module';
import { BillableListComponent } from 'src/app/billable/billable-list/billable-list.component';
import { BillableModule } from 'src/app/billable/billable.module';
import { ChannelsChatModule } from 'src/app/chat/chat.module';
import { DocumentLinkConsentComponent } from 'src/app/document/document-link-consent/document-link-consent.component';
import { MemberSearchComponent } from 'src/app/shared/member-search/member-search.component';
import { SystemLogComponent } from 'src/app/system-log/system-log.component';
import { SystemLogModule } from 'src/app/system-log/system-log.module';
import { AccumulatorListComponent } from 'src/app/accumulator/accumulator-list/accumulator-list.component';
import { AccumulatorModule } from 'src/app/accumulator/accumulator.module';
import { PermissionGuardService } from './permission-guard.service';

const NOT_FOUND_PAGE = 'not-found';

/**
 * route configurations
 */
export const routes: Routes = [
  {
    /*AuthGuardService that controlled if user is authenticated or not and redirect to login with return url*/
    path: '',
    canActivate: [AuthGuardService],
    /*Routes that requires permissions*/
    children: [
      {
        path: 'users', component: UserListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_ADMIN', 'ROLE_PROGRAM_LEAD', 'ROLE_REVENUE_MANAGER_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'groups', component: ChannelGroupListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'cases/:filter', component: CaseListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'cases/:filter/:filterAction', component: CaseListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'case/:id', component: CaseDetailComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'assessments/:filter', component: AssessmentListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_ADMIN'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'assessments', component: AssessmentListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_ADMIN'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'tasks', component: TaskListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'tasks/:filter', component: TaskListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'tasks/:filter/:filterAction', component: TaskListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'task/:id', component: TaskListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'referral-tasks/:filter', component: TaskListReferralComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_REFERRAL_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'referral-tasks', component: TaskListReferralComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_REFERRAL_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'members/:filter', component: MemberListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'members/:filter/:filterAction', component: MemberListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'members-search', component: MemberSearchComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'member/:id/assessments', component: MemberAssessmentComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'messages/:filter', component: MessageListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_DATA_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'patient/:id',
        component: PatientSummaryComponent,
        canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'patient-proxy/:id', component: PatientSummaryComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'channel-detail/:id', component: ChannelDetailComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'program-detail/:id', component: ProgramDetailComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'programs/:filter', component: ProgramListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'programs/:filter/:filterAction', component: ProgramListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'channels/:id/modeler/:modelId', component: ChannelModelerComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'channel-edit/:id', component: ChannelEditComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'channel-edit/:id/ruleset/:ruleSetId/rules', component: ChannelRuleComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'program-edit', component: ProgramEditComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'program-edit/:id', component: ProgramEditComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'program-categories', component: ProgramCategoryListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'metrics', component: MetricListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'channel-categories', component: ChannelCategoryListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'issuers', component: IssuerListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'insurers', component: InsurerListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_REVENUE_MANAGER_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'analytics/admin', component: AnalyticListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_DATA_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'analytics/:id', component: AnalyticViewComponent,
        canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_DATA_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'billable-services', component: BillableListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'accumulators', component: AccumulatorListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'extensions', component: ExtensionListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'assessment-types', component: AssessmentTypeListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'community-services', component: CommunityProviderProgramListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_ADMIN', 'ROLE_DIRECTORY_MANAGER'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'notices', component: NoticeListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'system-notes', component: SystemNoteListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'program-templates', component: ProgramTemplateListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'templates', component: EmailTemplateListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'organizations', component: OrganizationListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_REVENUE_MANAGER_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'field-configurations', component: FieldConfigurationListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'system-settings', component: SettingListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'dictionaries', component: CodeSetEditComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_ADMIN'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'dashboards/:filter', component: DashboardCoordinatorComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'clinical-messages', component: ClinicalMessageListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'events/:filter', component: ClinicalEventListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'providers', component: ProviderListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_DIRECTORY_MANAGER'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'patients-import', component: PatientImportListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'patients-merge', component: PatientMergeComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'facilities', component: FacilityListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'team-roles', component: TeamRoleListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'video-providers', component: VideoProviderListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'help-documents', component: HelpDocumentListComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'community-service-categories', component: CommunityServiceCategoryListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_ADMIN'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'terms-and-conditions', component: TermAndConditionListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'settings', component: SettingNavComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_SYSTEM_OPERATOR', 'ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_COMMUNITY_ADMIN', 'ROLE_COMMUNITY_COORDINATOR',
              'ROLE_DIRECTORY_MANAGER', 'ROLE_REVENUE_MANAGER_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'payer-billing', component: PayerBillingListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_REVENUE_MANAGER_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'generate-invoice', component: GenerateInvoiceComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_REVENUE_MANAGER_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'cbo-payments', component: CBOPaymentsListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_CBO_REVENUE_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'user/account', component: UserAccountComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: [],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'reports', component: ReportListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_COMMUNITY_ADMIN',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DATA_ANALYST'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'community-services-search', component: CommunityServiceSearchComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_COMMUNITY_ADMIN',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'system-logs', component: SystemLogComponent, canActivate: [PermissionGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'providers-search', component: ProviderServiceSearchComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_COMMUNITY_ADMIN',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'kno2-search', component: Kno2ServiceSearchComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_COMMUNITY_ADMIN',
              'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'integrity-tools', component: IntegrityListComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_OPERATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        }
      },
      {
        path: 'fhir/summary', component: FhirSummaryComponent, canActivate: [PermissionGuardService],
        data: {
          permissions: {
            only: ['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR',
              'ROLE_REFERRAL_COORDINATOR'],
            redirectTo: NOT_FOUND_PAGE
          }
        },
        children: [
          /* Nested FHIR routing for messages support**/
          { path: 'messages/:filter', component: MessageListComponent },
        ]
      },
    ]
  },
  /*This is an hidden page to test components used for Angular and Kendo upgrades*/
  {
    path: 'test', component: TestComponent,
    data: {
      permissions: {
        only: ['ROLE_OPERATOR'],
        redirectTo: NOT_FOUND_PAGE
      }
    }
  },
  /*Unauthenticated routes*/
  { path: 'help', component: HelpComponent },
  { path: 'login', component: LoginComponent },
  { path: 'totp', component: TotpComponent },
  { path: 'fhir/launch', component: SmartLaunchComponent },
  { path: 'fhir/redirect', component: SmartRedirectComponent },
  { path: 'registration/confirm/:token', component: UserConfirmComponent },
  { path: 'forgotpassword/confirm/:token', component: UserConfirmComponent },
  { path: 'documents/image/capture/:token', component: DocumentLinkUploadComponent },
  { path: 'documents/consent/capture/:token', component: DocumentLinkConsentComponent },
  { path: 'appointment/:token/:confirm', component: AppointmentConfirmComponent },
  { path: NOT_FOUND_PAGE, component: NotFoundComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'logout', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: NOT_FOUND_PAGE }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false }),
    UserModule,
    ProgramModule,
    CaseModule,
    MemberModule,
    MessageModule,
    ChannelsChatModule,
    TaskModule,
    FieldConfigurationModule,
    CodesetModule,
    OrganizationModule,
    DashboardCoordinatorModule,
    SettingModule,
    AssessmentModule,
    NoticeModule,
    SystemNoteModule,
    SystemLogModule,
    ClinicalMessageModule,
    PatientModule,
    ClinicalEventModule,
    ProviderModule,
    ChannelModule,
    EmailTemplateModule,
    VideoProviderModule,
    CommunityModule,
    TermAndConditionModule,
    FacilityModule,
    PatientImportModule,
    PayerBillingModule,
    CBOPaymentsModule,
    ReportModule,
    ExtensionModule,
    PatientMergeModule,
    HelpDocumentModule,
    MetricModule,
    IssuerModule,
    InsurerModule,
    AnalyticModule,
    IntegrityModule,
    TestModule,
    FhirModule,
    BillableModule,
    AccumulatorModule
  ],
  providers: [CanDeactivateGuard],
  exports: [
    RouterModule
  ]
})
export class RoutingModule { }
